<template src="./MessageDiffuser.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      messages: [],
      messagesPaginated: [],
      popupMessage: false,
      titlePopupMessage: "",
      messageId: null,
      description: null,
      days: null,
      text: null,
      active: true,
      invalidFields: {
        description: false,
        days: false,
        text: false
      },
      saveClicked: false,
      windowWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      search: "",
    };
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    description: function(newVal) {
      this.invalidFields.description = this.testNullUndefinedEmpty(newVal) && this.saveClicked;
    },
    days: function(newVal) {
      this.invalidFields.days = this.testNullUndefinedEmpty(newVal) && this.saveClicked;
    },
    text: function(newVal) {
      this.invalidFields.text = this.testNullUndefinedEmpty(newVal) && this.saveClicked;
    },
    currentx: function() {
      this.getMessageList();
    }
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getMessageList();
    },
    newMessage() {
      const vm = this;
      vm.saveClicked = false,
      vm.invalidFields = {description: false, days: false, text: false};
      vm.titlePopupMessage = "Nova mensagem";
      vm.clearMessageFields();
      vm.popupMessage = true;
    },
    getMessageList() {
      const vm = this;
      vm.$vs.loading();
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(vm.$store.state.filooServer + `message/list?page=${vm.currentx-1}&size=10&search=${vm.search}`)
        .then(function (response) {
          if (response.status === 200) {
            vm.messages = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
            vm.$vs.loading.close();
          }
        })
        .catch(function () {
          vm.$vs.loading.close();
        });
    },

    postNewMessage() {
      const vm = this;
      let message = {
        active: vm.active,
        description: vm.description,
        days: vm.days,
        text: vm.text,
      };
      vm.axios
        .post(
          vm.$store.state.filooServer + "message/create",
          message,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.popupMessage = false;
            vm.$swal(
              "Operação realizada!",
              "A mensagem <b style='color: #FF9F43; font-weight: 500'>" +
                vm.description +
                "</b> foi adicionado com sucesso.",
              "success"
            );
            vm.$nextTick(() => {
              vm.getMessageList();
            });
          }
        })
        .catch(function () {
          vm.popupMessage = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar a operação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    putMessage(isStatus) {
      const vm = this;
      let message = {
        id: vm.id,
        active: vm.active,
        description: vm.description,
        days: vm.days,
        text: vm.text
      };
      vm.axios
        .put(vm.$store.state.filooServer + "message/update/"+ vm.id, message, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.popupMessage = false;
            if(isStatus) {
              vm.$nextTick(() => {
                vm.removeFocus();
              });
            } else {
              vm.$swal(
                "Operação realizada!",
                "A mensagem <b style='color: #FF9F43; font-weight: 500'>" +
                  vm.description +
                  "</b> foi alterado com sucesso.",
                "success"
              );
            }
            vm.$nextTick(() => {
              vm.getMessageList();
            });
          }
        })
        .catch(function () {
          vm.popupMessage = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar a operação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    editMessage(message) {
      const vm = this;
      vm.saveClicked = false,
      vm.clearMessageFields();
      vm.id = message.id,
      vm.active = message.active,
      vm.description = message.description,
      vm.days = message.days,
      vm.text = message.text,
      vm.titlePopupMessage = "Editar Mensagem - " + message.description;
      vm.popupMessage = true;
    },
    clearMessageFields() {
      const vm = this;
      vm.active = true;
      vm.description = null;
      vm.days = null;
      vm.text = null;
    },
    save() {
      const vm = this;
      vm.saveClicked = true;
      if (vm.validateFields() ) {
        vm.testNullUndefinedEmpty(vm.id) ?
          vm.postNewMessage()
          :vm.putMessage();
      } else {
        vm.$nextTick(() => {
          vm.removeFocus();
        });
      }
    },
    changeStatus(message) {
      const vm = this;
      vm.id = message.id,
      vm.active = !message.active,
      vm.description = message.description,
      vm.days = message.days,
      vm.text = message.text,
      vm.putMessage(true);
    },
    removeFocus() {
      document.activeElement.blur()
    },
    validateFields() {
      const vm = this;
      const invalid = vm.invalidFields;
      invalid.description = vm.testNullUndefinedEmpty(vm.description);
      invalid.days = vm.testNullUndefinedEmpty(vm.days);
      invalid.text = vm.testNullUndefinedEmpty(vm.text);

      return !(invalid.description || invalid.days || invalid.text)
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
    handleSearch(search) {
      this.search = search
      this.getMessageList()
    }
  },
};
</script>
<style lang="scss" src="./MessageDiffuser.scss">
</style>